/**
 * The two marks that say whether a circle is software or somebody.
 *
 * They live apart from the panels that draw them because there are now two of those — the
 * population badge in the corner and the death screen's "who ate you" line — and the whole point
 * of the mark is that it is *one* signal: a player who has learnt "cyan robot means AI" from the
 * badge on a blob (`../bot-mark.ts`, `ArenaScene.drawBotBadge`) should read both for free. Two
 * copies of the same path is exactly how that stops being true.
 *
 * `currentColor` on the fills, so each caller tints its own; the ink inside the robot's face is
 * fixed, because it has to stay dark against the cyan whatever the surrounding text is doing.
 */

export interface GlyphProps {
  /** Sizing and colour are the caller's; the default is the size the HUD's type wants. */
  className?: string;
}

/** A head and shoulders, at the type's own size. */
export function HumanGlyph({ className = 'h-3.5 w-3.5 shrink-0' }: GlyphProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      className={className}
      fill="currentColor"
      role="img"
      aria-label="Human"
    >
      <circle cx="8" cy="5" r="3" />
      <path d="M2 15a6 6 0 0 1 12 0Z" />
    </svg>
  );
}

/** The same robot's head the badge on a bot's blob draws, at icon size. */
export function BotGlyph({ className = 'h-3.5 w-3.5 shrink-0' }: GlyphProps) {
  return (
    <svg viewBox="0 0 16 16" className={className} fill="currentColor" role="img" aria-label="Bot">
      <path d="M8 0.5v2" stroke="currentColor" strokeWidth="1.2" />
      <circle cx="8" cy="1" r="1.2" />
      <rect x="2" y="4" width="12" height="10" rx="3" />
      <circle cx="5.5" cy="8" r="1.4" fill="#06212b" />
      <circle cx="10.5" cy="8" r="1.4" fill="#06212b" />
      <rect x="6" y="11" width="4" height="1.2" rx="0.6" fill="#06212b" />
    </svg>
  );
}
